<div class="modal-edit-document">
  <h2 mat-dialog-title>Edit Document</h2>

  <mat-dialog-content>
    <form [formGroup]="editForm" class="edit-document-form">

      <!-- Document Title (Read-only display) -->
      <div class="document-title-section">
        <h4>{{ data.document.title }}</h4>
        <small class="text-muted">Document ID: {{ data.document.id }}</small>
      </div>

      <div class="form-row">
        <!-- Authors -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Authors</mat-label>
          <input matInput formControlName="authors" placeholder="Enter authors names">
          <mat-error>{{ getFormErrorMessage('authors') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <!-- Year -->
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Year</mat-label>
          <input matInput type="number" formControlName="year" placeholder="Publication year">
          <mat-error>{{ getFormErrorMessage('year') }}</mat-error>
        </mat-form-field>

        <!-- Study Type -->
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Study Type</mat-label>
          <mat-select formControlName="study_type">
            @for (type of studyTypeOptions; track type) {
              <mat-option [value]="type">
                {{ type }}
              </mat-option>
            }
          </mat-select>
          <mat-error>{{ getFormErrorMessage('study_type') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <!-- Main Outcome -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Main Outcome</mat-label>
          <textarea matInput formControlName="main_outcome"
            rows="3"
          placeholder="Describe the main outcome of the study"></textarea>
          <mat-error>{{ getFormErrorMessage('main_outcome') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="grade-section">
        <h4>GRADE Assessment</h4>

        <div class="form-row">
          <!-- Precision -->
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>Precision</mat-label>
            <mat-select formControlName="precision">
              <mat-select-trigger>
                <span class="select-trigger-content">
                  <mat-icon [style.color]="getQualityColor(editForm.get('precision')?.value)">
                    {{ getQualityIcon(editForm.get('precision')?.value) }}
                  </mat-icon>
                  {{ formatGradeQuality(editForm.get('precision')?.value) }}
                </span>
              </mat-select-trigger>
              @for (quality of gradeQualityOptions; track quality) {
                <mat-option [value]="quality">
                  <mat-icon [style.color]="getQualityColor(quality)">{{ getQualityIcon(quality) }}</mat-icon>
                  {{ formatGradeQuality(quality) }}
                </mat-option>
              }
            </mat-select>
            <mat-error>{{ getFormErrorMessage('precision') }}</mat-error>
          </mat-form-field>

          <!-- Consistency -->
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>Consistency</mat-label>
            <mat-select formControlName="consistency">
              <mat-select-trigger>
                <span class="select-trigger-content">
                  <mat-icon [style.color]="getQualityColor(editForm.get('consistency')?.value)">
                    {{ getQualityIcon(editForm.get('consistency')?.value) }}
                  </mat-icon>
                  {{ formatGradeQuality(editForm.get('consistency')?.value) }}
                </span>
              </mat-select-trigger>
              @for (quality of gradeQualityOptions; track quality) {
                <mat-option [value]="quality">
                  <mat-icon [style.color]="getQualityColor(quality)">{{ getQualityIcon(quality) }}</mat-icon>
                  {{ formatGradeQuality(quality) }}
                </mat-option>
              }
            </mat-select>
            <mat-error>{{ getFormErrorMessage('consistency') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <!-- Risk of Bias -->
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>Risk of Bias</mat-label>
            <mat-select formControlName="risk_of_bias">
              <mat-select-trigger>
                <span class="select-trigger-content">
                  <mat-icon [style.color]="getRiskColor(editForm.get('risk_of_bias')?.value)">
                    {{ getRiskIcon(editForm.get('risk_of_bias')?.value) }}
                  </mat-icon>
                  {{ formatRiskOfBias(editForm.get('risk_of_bias')?.value) }}
                </span>
              </mat-select-trigger>
              @for (risk of riskOfBiasOptions; track risk) {
                <mat-option [value]="risk">
                  <mat-icon [style.color]="getRiskColor(risk)">{{ getRiskIcon(risk) }}</mat-icon>
                  {{ formatRiskOfBias(risk) }}
                </mat-option>
              }
            </mat-select>
            <mat-error>{{ getFormErrorMessage('risk_of_bias') }}</mat-error>
          </mat-form-field>

          <!-- Grade Quality -->
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>Grade Quality</mat-label>
            <mat-select formControlName="grade_quality">
              <mat-select-trigger>
                <span class="select-trigger-content">
                  <mat-icon [style.color]="getQualityColor(editForm.get('grade_quality')?.value)">
                    {{ getQualityIcon(editForm.get('grade_quality')?.value) }}
                  </mat-icon>
                  {{ formatGradeQuality(editForm.get('grade_quality')?.value) }}
                </span>
              </mat-select-trigger>
              @for (quality of gradeQualityOptions; track quality) {
                <mat-option [value]="quality">
                  <mat-icon [style.color]="getQualityColor(quality)">{{ getQualityIcon(quality) }}</mat-icon>
                  {{ formatGradeQuality(quality) }}
                </mat-option>
              }
            </mat-select>
            <mat-error>{{ getFormErrorMessage('grade_quality') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-button">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="editForm.invalid"
      class="save-button">
      <mat-icon>save</mat-icon>
      Save Changes
    </button>
  </mat-dialog-actions>
</div>